import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) return '';

    let decoded = value;

    // If the response contains &lt; or &gt;, decode it
    if (decoded.includes('&lt;') || decoded.includes('&gt;')) {
      const parser = new DOMParser();
      decoded = parser.parseFromString(decoded, 'text/html').body.textContent || decoded;
    }

    // Always sanitize the final HTML
    return this.sanitizer.bypassSecurityTrustHtml(decoded);
  }
}
